import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { LogOut, User, Home } from 'lucide-react';
import { AccountMenu } from '@/components/dashboard/AccountMenu';

interface HeaderProps {
  onNavigateToProfile: () => void;
  onNavigateToHome: () => void;
}

export const Header = ({ onNavigateToProfile, onNavigateToHome }: HeaderProps) => {
  const { user, profile } = useAuth();

  if (!user) return null;

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
        <div className="flex items-center">
          <div className="flex items-center">
            <img 
              src="/lovable-uploads/c941c7a1-d271-4c8b-91a4-2611677da8a6.png" 
              alt="Getproof Logo"
              className="h-8 mr-3"
            />
          </div>
        </div>
          
          <div className="flex items-center space-x-4">
            <Button variant="ghost" onClick={onNavigateToHome}>
              <Home className="h-4 w-4 mr-2" />
              Accueil
            </Button>
            
            <AccountMenu onNavigateToProfile={onNavigateToProfile} />
          </div>
        </div>
      </div>
    </header>
  );
};
